import { BaseService, Service } from "/@/cool";
import { getSubmitModelingErrorMessage } from "../utils/submit-modeling-error.mjs";

@Service("model")
class Model extends BaseService {
	constructor() {
		super();

		let prefix = "";
		if (this.namespace) {
			prefix = this.namespace.replace(/\//g, ":") + ":";
		}

		this.permission["add"] = prefix + "add";
		this.permission["update"] = prefix + "update";
		this.permission["info"] = prefix + "info";
		this.permission["list"] = prefix + "list";
		this.permission["page"] = prefix + "page";
		this.permission["delete"] = prefix + "delete";
		this.permission["glb"] = prefix + "glb";
		this.permission["saveAngle"] = prefix + "saveAngle";
		this.permission["angle"] = prefix + "angle";
		this.permission["url"] = prefix + "url";
		this.permission["photo"] = prefix + "photo";
		this.permission["submitModelingByShop"] = prefix + "submitModelingByShop";
		this.permission["glbForExternalOrder"] = prefix + "glbForExternalOrder";
		this.permission["glbForRepairReject"] = prefix + "glbForRepairReject";
	}

	//下单
	glb(data: {}) {
		return this.request({
			url: "/glb",
			method: "POST",
			data
		});
	}

	// 角度
	angle(data: {}) {
		return this.request({
			url: "/angle",
			method: "POST",
			data
		});
	}

	// 建模
	submitModelingByShop(params: any) {
		return this.request({
			url: "/submitModelingByShop",
			method: "POST",
			data: { ...params }
		}).catch((error: any) => {
			const normalizedMessage = getSubmitModelingErrorMessage(error);
			if (!normalizedMessage) {
				return Promise.reject(error);
			}

			if (error && typeof error === "object") {
				error.message = normalizedMessage;
				return Promise.reject(error);
			}

			return Promise.reject({
				message: normalizedMessage
			});
		});
	}
	glbForExternalOrder(params: any) {
		return this.request({
			url: "/glbForExternalOrder",
			method: "POST",
			data: { ...params }
		});
	}
	glbForRepairReject(params: any) {
		return this.request({
			url: "/glbForRepairReject",
			method: "POST",
			data: { ...params }
		});
	}

	/** 卡通预览图：GET /admin/model/photo?id=&pid=&type=&order_id= */
	photo(params: { id?: number; pid: number; type: number; order_id: number }) {
		return this.request({
			url: "/photo",
			method: "GET",
			params: {
				id: params.id ?? 0,
				pid: params.pid,
				type: params.type,
				order_id: params.order_id
			}
		});
	}
}
export default Model;
